import { render, staticRenderFns } from "./AzureAuthLogin.vue?vue&type=template&id=5915e9aa&scoped=true"
import script from "./AzureAuthLogin.vue?vue&type=script&lang=js"
export * from "./AzureAuthLogin.vue?vue&type=script&lang=js"
import style0 from "./AzureAuthLogin.vue?vue&type=style&index=0&id=5915e9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915e9aa",
  null
  
)

export default component.exports